
import React from "react";

export default function Alerts({ prAgeing, dashboardAlert }) {

    const alerts = [
        {
            icon: "bi bi-exclamation-triangle-fill",
            iconColor: "#DC2626",
            bgColor: "#FEF2F2",
            text: `${prAgeing?.["> 5 Days"] || 0} PRs pending approval for > 5 days`
        },
        {
            icon: "bi bi-clock-fill",
            iconColor: "#EA580C",
            bgColor: "#FFF7ED",
            text:  `${dashboardAlert?.count || 0} RFQs closing today`
        },
        // {
        //     icon: "bi bi-file-earmark-x-fill",
        //     iconColor: "#CA8A04",
        //     bgColor: "#FEFCE8",
        //     text: "3 Vendor documents expired"
        // },
        // {
        //     icon: "bi bi-cash-stack",
        //     iconColor: "#9333EA",
        //     bgColor: "#F3E8FF",
        //     text: "Budget exceeded in Mechanical category"
        // },
        // {
        //     icon: "bi bi-check-circle-fill",
        //     iconColor: "#16A34A",
        //     bgColor: "#F0FDF4",
        //     text: "8 Auctions completed today"
        // }
    ];

    return (

        <div className="dashboardWidget3">

            <div className="widgetHeader3">
                <h6>Alerts</h6>
                {/* <span>View All</span> */}
            </div>

            <div className="alertsContainer">
                {
                    alerts.map((item, index) => (
                        <div
                            className="alertItem"
                            key={index}
                            style={{
                                backgroundColor: item.bgColor
                            }}
                        >
                            <div
                                className="alertIcon"
                                style={{
                                    background: "#fff",
                                    color: item.iconColor
                                }}
                            >
                                <i className={item.icon}></i>
                            </div>
                            <div className="alertText">
                                {item.text}
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}
